import styled, { css } from "styled-components";

interface MenuItemProps {
  isSelected?: boolean;
}

export const Container = styled.div`
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px;  
  }
`;

export const MenuContainer = styled.nav`
  display: flex;
  justify-content: center;
  padding: 1rem;
`;

export const MenuItem = styled.div<MenuItemProps>`
  margin: 0 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  width: 200px;
  height: 40px; /* Altura fixa para centralizar verticalmente */
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ isSelected }) => (isSelected ? "#fff" : "#333")};
  background-color: ${({ isSelected }) =>
    isSelected ? "#ec0065" : "transparent"};
  border: 1px solid ${({ isSelected }) => (isSelected ? "transparent" : "#ccc")};
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    color: #fff;
    border-color: #1c0069;
    background-color: #1c0069;
  }
`;
